import { LoadingLine } from "../../../components/loading-line.js";
import { UserPrivateRealStateModel } from "./model.js";
import { UserPrivateRealStateView } from "./view.js";
import { ITEM_OPTIONS } from "../../../config/constants.js";
import { ModalController } from "../../../components/modal/controller.js";
import { CheckInputValue } from "../../../config/functions.js";
import { LoadingDot } from "../../../components/loading-dot.js";
import { Doms } from "../../../components/doms.js";

export class UserPrivateRealStateController {
  constructor() {
    this.model = new UserPrivateRealStateModel();
    this.view = new UserPrivateRealStateView();
    this.loading = LoadingLine.getInstance();
    this.doms = new Doms();

    this.modal = null;
    this.openning = false;
  }

  async loadMain() {
    app.userPrivateController.viewGenericItems.loadMain(this, 'Mis inmuebles', 'inmuebles');

    history.pushState({}, '', `/user/inmuebles`);
    document.getElementById('btn-inmuebles').classList.add('active');
    document.getElementById('btn-header-inmuebles').classList.add('active');

  }

  new() {
    history.pushState({}, '', `/user/inmuebles/new`);
    this.modal = new ModalController("Publicar nuevo inmueble", LoadingDot.render() + '<br><br>', 'form-inmuebles', app.userPrivateController.view.renderPublishButton('1'));
    app.userPrivateController.auth.sessionAlive()
      .then(() => {
        this.modal.doms.content.innerHTML = this.view.renderForm();
        APICRUD.Common.Select.SetData('inmuebles-categoria', 0, ITEM_OPTIONS.Categorias.Inmuebles);
        APICRUD.Common.Select.SetData('inmuebles-moneda', 0, ITEM_OPTIONS.Monedas);
        APICRUD.Location.Selector_LoadStates('inmuebles-provincia', '5', '0');
        APICRUD.Location.Selector_LoadCities('inmuebles-localidad', '0', '0');
      })
      .catch(_error => {
        console.log(_error);
        this.modal.doms.modal.innerHTML = '';
        this.modal.close();
        app.userPrivateController.auth.showLogin()
      })
  }

  create() {
    if (this.modal?.modal?.classList.contains('active')) {
      this.modal.doms.content.innerHTML = this.view.renderForm();
      this.view.gallery.checkButtons();
    } else {
      this.modal = new ModalController("Publicar nuevo inmueble", this.view.renderForm(), 'form-inmuebles', app.userPrivateController.view.renderPublishButton('1'));
      this.modal.show();
      this.view.gallery.checkButtons();
    }
    APICRUD.Common.Select.SetData('inmuebles-categoria', 0, ITEM_OPTIONS.Categorias.Inmuebles);
    APICRUD.Common.Select.SetData('inmuebles-moneda', 0, ITEM_OPTIONS.Monedas);
    APICRUD.Location.Selector_LoadStates('inmuebles-provincia', '5', '0');
    APICRUD.Location.Selector_LoadCities('inmuebles-localidad', '0', '0');
  }

  edit(_idcod) {
    if (this.openning === true) return;
    this.openning = true;
    this.modal = new ModalController("Editar inmueble", LoadingDot.render() + '<br><br>', 'form-inmuebles', '<br>');
    this.modal.show();
    this.loading.show();
    this.model.read(_idcod)
      .then((inmueble) => {
        this.modal.doms.content.innerHTML = this.view.renderForm(inmueble.data);
        this.modal.doms.titleStatus.innerHTML = app.userPrivateController.view.renderPublishButton(inmueble.data.visible);
        this.view.gallery.checkButtons();
        APICRUD.Common.Select.SetData('inmuebles-categoria', inmueble.data.categoria, ITEM_OPTIONS.Categorias.Inmuebles);
        APICRUD.Common.Select.SetData('inmuebles-moneda', inmueble.data.moneda, ITEM_OPTIONS.Monedas);
        APICRUD.Location.Selector_LoadStates('inmuebles-provincia', '5', inmueble.data.provincia);
        APICRUD.Location.Selector_LoadCities('inmuebles-localidad', inmueble.data.provincia, inmueble.data.localidad);
      })
      .catch(error => {
        console.log(error);
        this.modal.close();
        let modal = new ModalController('Editar inmueble', 'No existe el inmueble.');
        modal.show();
        setTimeout(modal.close.bind(this), 5000);
      })
      .finally(() => {
        this.openning = false;
        this.loading.hide();
      });
  }

  delete(_title, _idcod) {
    this.modalDelete = new ModalController('Eliminar inmueble');
    this.modalDelete.doms.content.innerHTML = this.view.renderDeleteConfirmation(_title, _idcod);
  }

  deleteConfirmation(_idcod) {
    this.model.delete(_idcod)
      .then(() => {
        this.modal?.close();
        this.modalDelete?.close();
        app.userPrivateController.router('inmuebles');
      })
      .catch(_error => {
        this.modalDelete.doms.content.innerHTML = _error;
        console.error(_error);
      });
  }

  deleteCancel() {
    this.modalDelete?.close();
  }

  save() {
    return new Promise(async (resolve, reject) => {
      let idcod = document.getElementById('inmuebles-idcod')?.value;
      let newData = {
        titulo: document.getElementById('inmuebles-titulo').value,
        resumen: document.getElementById('inmuebles-resumen').value,
        descripcion: document.getElementById('inmuebles-descripcion').value,
        imagenes: this.view.gallery.images,
        categoria: document.getElementById('inmuebles-categoria').value,
        metros: document.getElementById('inmuebles-metros').value,
        precio: document.getElementById('inmuebles-precio').value,
        moneda: document.getElementById('inmuebles-moneda').value || '0',
        localidad: document.getElementById('inmuebles-localidad').value || '0',
        provincia: document.getElementById('inmuebles-provincia').value || '0',
        visible: document.getElementById('visible').checked === true ? '1' : '0'
      }

      if (idcod) {
        newData.idcod = idcod;
      }

      document.getElementById('inmuebles-titulo-error').innerHTML = '';
      document.getElementById('inmuebles-categoria-error').innerHTML = '';
      document.getElementById('inmuebles-resumen-error').innerHTML = '';
      document.getElementById('inmuebles-descripcion-error').innerHTML = '';
      document.getElementById('inmuebles-precio-error').innerHTML = '';
      document.getElementById('inmuebles-moneda-error').innerHTML = '';
      document.getElementById('inmuebles-metros-error').innerHTML = '';
      document.getElementById('inmuebles-status').innerHTML = '';

      if (!newData.categoria || newData.categoria === '0') {
        document.getElementById('inmuebles-categoria-error').innerHTML = 'Debe seleccionar una categoría.';
        document.getElementById('inmuebles-categoria').focus();
        return;
      } else if (!newData.titulo) {
        document.getElementById('inmuebles-titulo-error').innerHTML = 'El título no puede estar vacío.';
        document.getElementById('inmuebles-titulo').focus();
        return;
      } else if (newData.titulo.length < 5) {
        document.getElementById('inmuebles-titulo-error').innerHTML = 'El título debe tener al menos 5 caracteres.';
        document.getElementById('inmuebles-titulo').focus();
        return;
      } else if (!newData.resumen) {
        document.getElementById('inmuebles-resumen-error').innerHTML = 'La descripción corta no puede estar vacía.';
        document.getElementById('inmuebles-resumen').focus();
        return;
      } else if (newData.resumen.length < 20) {
        document.getElementById('inmuebles-resumen-error').innerHTML = 'La descripción debe tener al menos 20 caracteres.';
        document.getElementById('inmuebles-resumen').focus();
        return;
      } else if (!newData.metros || newData.metros === '0') {
        document.getElementById('inmuebles-metros-error').innerHTML = 'Debe ingresar la superficie del inmueble.';
        document.getElementById('inmuebles-metros').focus();
        return;
      } else if (!CheckInputValue('inmuebles-metros') && parseFloat(document.getElementById('inmuebles-metros').value) == 0) {
        document.getElementById('inmuebles-metros-error').innerHTML = 'La superficie no es válida.';
        document.getElementById('inmuebles-metros').focus();
        return;
      } else if (document.getElementById('inmuebles-precio-radio-1').checked == true) {
        if (newData.precio.trim() == '' || newData.precio.trim() == '0') {
          document.getElementById('inmuebles-precio-error').innerHTML = 'El precio no puede estar vacío.';
          document.getElementById('inmuebles-precio').focus();
          return;
        } else if (!CheckInputValue('inmuebles-precio')) {
          document.getElementById('inmuebles-precio-error').innerHTML = 'El precio no puede ser menor a cero.';
          document.getElementById('inmuebles-precio').focus();
          return;
        } else if (newData.moneda === '0') {
          document.getElementById('inmuebles-moneda-error').innerHTML = 'Debe seleccionar una moneda.';
          document.getElementById('inmuebles-moneda').focus();
          return;
        }
      } else if (newData.provincia === '0') {
        document.getElementById('inmuebles-provincia-error').innerHTML = 'Debe seleccionar una provincia.';
        document.getElementById('inmuebles-provincia').focus();
        return;
      } else if (newData.localidad === '0') {
        document.getElementById('inmuebles-localidad-error').innerHTML = 'Debe seleccionar una localidad.';
        document.getElementById('inmuebles-localidad').focus();
        return;
      }

      document.getElementById('inmuebles-status').innerHTML = 'Guardando...';

      let func = 'Create';
      let text = 'Creando nuevo inmueble';
      if (newData.idcod) {
        func = 'Update';
        text = 'Guardando inmueble';
      }

      if (await app.userPrivateController.account.canPublish(this.doms.getDom('visible').checked, newData.idcod) === false) {
        document.getElementById('visible').checked = false;
        newData.visible = '0';
      }

      let modalSave = new ModalController('Guardando', 'Enviando datos, por favor espere...');
      modalSave.show();
      this.loading.show(text);
      this.model.save(newData, func)
        .then(_result => {
          document.getElementById('inmuebles-status').innerHTML = 'Datos guardados.';
          app.userPrivateController.router('inmuebles');
          app.userPrivateController.inmuebles.modal.close();
          modalSave.doms.content.innerHTML = 'Datos guardados.';
          resolve();
        })
        .catch(_error => {
          document.getElementById('inmuebles-status').innerHTML = _error;
          modalSave.doms.content.innerHTML = _error;
          reject();
        })
        .finally(() => {
          this.loading.hide();
          modalSave.close();
        });

    });
  }
}
